export const CREATE_REQUEST_LOAN = "CREATE_REQUEST_LOAN";
export const FETCH_REQUEST_LOANS = "FETCH_REQUEST_LOANS";
export const FETCH_REQUEST_LOAN = "FETCH_REQUEST_LOAN";
export const EDIT_REQUEST_LOAN = "EDIT_REQUEST_LOAN";
export const DELETE_REQUEST_LOAN = "DELETE_REQUEST_LOAN";
